import { KeyValuePair } from "../key-value-pair";

export class ReimbursementConstants {

    public static RENTAL = "Rental";
    public static TOWING = "Towing";
    public static TRIP = "Trip Interruption";

    public static ReimbursementTypes: KeyValuePair[] = [
        {key: this.RENTAL, value: this.RENTAL},
        {key: this.TOWING, value: this.TOWING},
        {key: this.TRIP, value: this.TRIP}
    ]
}